












import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'

import { ButtonStruct } from '../../buttons'

@Component
export default class NewButtonViewWrapper extends Vue {
  @Prop({ type: Object }) model!: ButtonStruct

  @Prop({ type: Boolean }) readonly isDisabledMoveBack!: boolean

  @Prop({ type: Boolean }) readonly isDisabledMoveForward!: boolean

  @Prop({ type: String }) readonly icon!: string | null

  @Prop({ type: Boolean, default: false }) readonly disabled!: boolean

  @Prop({ required: true }) buttonView!: typeof Vue

  @Prop({ required: true }) setupView!: { component: typeof Vue, props: { [key: string]: any } }
}
